<template>
  <div 
    :class="{'internalTitleDescriptionImage--contentLeftPosition' : contentLeft}"
    class="internalTitleDescriptionImage">
    <div 
      v-waypoint="{ active: true, callback: $_onWaypoint, options: intersectionOptions }"
      class="internalTitleDescriptionImage__content">
      <h3 v-html="title"/>
      <div 
        v-if="typeof description !== 'undefined'" 
        v-html="description"
        class="internalTitleDescriptionImage__content__description"></div>
    </div>
    <picture 
      v-waypoint="{ active: true, callback: $_onWaypoint, options: intersectionOptions }"
      class="internalTitleDescriptionImage__picture">
      <source :srcset="srcSetImages.landscape" media="(orientation: landscape)">
      <img :src="srcSetImages.portrait" :alt="title">
    </picture>
    <blockquote 
      v-waypoint="{ active: true, callback: $_onWaypoint, options: intersectionOptions }"
      class="internalTitleDescriptionImage__blockquote"
      v-html="blockquote"/>
  </div>
</template>

<script>

import waypointEffect from '@/mixins/waypointEffect.js'

export default {
  name: 'InternalTitleDescriptionImage',
  mixins: [waypointEffect],
  props: {
    srcSetImages: {
      type: Object,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: false
    },
    blockquote: {
      type: String,
      required: false
    },
    contentLeft: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">
  @import "./internalTitleDescImg.scss";
  @import "./waypoint-effects.scss";
</style>
  